import { jsx } from 'react/jsx-runtime';
import { useContext, useCallback, isValidElement, cloneElement } from 'react';
import { ModalHistoryContext } from '../History/History.js';

const ModalLink = ({ pathname, options, query, children, onClick, className, ...props })=>{
    const history = useContext(ModalHistoryContext);
    /**
     * On Link Click.
     */ const handleClick = useCallback((e)=>{
        e.preventDefault();
        e.stopPropagation();
        history.push({
            pathname,
            options,
            query
        });
        onClick?.();
    }, [
        history,
        onClick,
        options,
        pathname,
        query
    ]);
    /**
     * Pass onClick event to children if valid.
     */ if (/*#__PURE__*/ isValidElement(children)) {
        return /*#__PURE__*/ cloneElement(children, {
            ...props,
            onClick: handleClick
        });
    }
    /**
     * Fallback to anchor tag on text children.
     */ return jsx("a", {
        href: pathname,
        ...props,
        className: className,
        onClick: handleClick,
        children: children
    });
};

export { ModalLink };
//# sourceMappingURL=Link.js.map
